import React from 'react';
import * as signalR from '@microsoft/signalr';
import isNil from 'lodash';

import Utils from '../../utils';

export const LiveSignalRContext = React.createContext(null);

interface LiveSignalRProviderProps {
    serverUrl: string;
    onRate?: Function;
    onLocations?: Function;
    children?: any;
}

export const LiveSignalRProvider = (props: LiveSignalRProviderProps) => {
    const [hub, setHub] = React.useState(null);

    const onRateRef = React.useRef(props.onRate); 
    const onLocationsRef = React.useRef(props.onLocations);

    React.useEffect(() => { 
        onRateRef.current = props.onRate; 
    }, [props.onRate]); 

    React.useEffect(() => { 
        onLocationsRef.current = props.onLocations; 
    }, [props.onLocations]);

    React.useEffect(() => {
        if (Utils.isNullOrWhitespace(props.serverUrl)) {
            setHub(null);

            return;
        }

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(props.serverUrl)
            .withAutomaticReconnect([0, 2000, 10000, 30000]) // Retry delays
            .configureLogging(signalR.LogLevel.Information)
            .build();

        setHub(connection);

        const handleRate = (...args: any[]) => onRateRef.current?.(...args); 
        const handleLocations = (...args: any[]) => onLocationsRef.current?.(...args);

        connection.on('updaterates', handleRate); 
        connection.on('updatelocations', handleLocations);

        connection.start().catch((err) => {
            console.warn('SignalR live hub initial start failed:', err);
        });

        return () => {
            connection.stop().catch(() => {});
        };
    }, [props.serverUrl]);

    return (
        <LiveSignalRContext.Provider value={hub}>
            {props.children}
        </LiveSignalRContext.Provider>
    );
};
